// extracted by css-extract-rspack-plugin
export default {"Octicon_0":"FilterRevert-module__Octicon_0__H5m1S","Link_0":"FilterRevert-module__Link_0__fUoJU"};